var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNameIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.47722 8.6582C11.6415 8.6582 13.3961 6.90368 13.3961 4.73938C13.3961 2.57507 11.6415 0.820557 9.47722 0.820557C7.31291 0.820557 5.55838 2.57507 5.55838 4.73938C5.55838 6.90368 7.31291 8.6582 9.47722 8.6582Z",
    stroke: "white",
    strokeWidth: 1.23,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.26444 17.242H15.6902C17.0671 17.242 18.1277 16.0581 17.4848 14.8406C16.5388 13.0496 14.3825 10.9116 9.47731 10.9116C4.57214 10.9116 2.41577 13.0496 1.46991 14.8406C0.826891 16.0581 1.88752 17.242 3.26444 17.242Z",
    stroke: "white",
    strokeWidth: 1.23,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNameIcon);
export default __webpack_public_path__ + "static/media/name-icon.3887ee35789c7f70ca28be7859ec7d0f.svg";
export { ForwardRef as ReactComponent };